import React from "react"
import styles from "./CodeBlockValidatableInput.module.scss"
import { useField } from "formik"
import cn from "classnames"
import { Form, FormGroup } from "react-bootstrap"
import CodeBlockInput from "../CodeBlockInput/CodeBlockInput"
import { Language } from "prism-react-renderer"
import { useTranslation } from "react-i18next"
import InputLabel from "../FormHelpers/InputLabel/InputLabel"
import CloseButton from "../CloseButton/CloseButton"

export interface CodeBlockValidatableInputProps {
    id: string
    name: string
    label: string
    disabled?: boolean
    language?: Language
    onDelete?: () => void
}

const EDITOR_PADDING = 20

const CodeBlockValidatableInput: React.FC<CodeBlockValidatableInputProps> = props => {
    const { t } = useTranslation()

    const [field, meta, helpers] = useField<string>(props)
    const { id, label, disabled, language, onDelete } = props

    const error = meta.touched && meta.error ? t(meta.error) : undefined

    return (
        <FormGroup className={styles.codeBlockValidatableInput} controlId={id}>
            <InputLabel label={label}>
                {onDelete && <CloseButton onClick={onDelete} disabled={disabled} className={styles.closeBtn} />}
            </InputLabel>
            <CodeBlockInput
                value={field.value ?? ""}
                initial={false}
                isEditable={true}
                onChange={code => {
                    helpers.setValue(code, false)

                    setTimeout(() => {
                        helpers.setTouched(true, true)
                    }, 100)
                }}
                className={cn(
                    styles.codeBlockValidatableInput__control,
                    error && styles.codeBlockValidatableInput__control_invalid,
                    disabled && styles.codeBlockValidatableInput__control_disabled
                )}
                padding={EDITOR_PADDING}
                disabled={disabled}
                language={language}
            />
            <Form.Control.Feedback type="invalid" className={cn(error && styles.codeBlockValidatableInput_invalid)}>
                {error}
            </Form.Control.Feedback>
        </FormGroup>
    )
}

export default CodeBlockValidatableInput
